import React from "react";
import ContactInfoScreen from "../../../../Contacts/ContactInfoScreen";
import { defaultNavigationProps } from "../../../Navigator";
import { dealer } from "../../../../WhereToBuy/Interfaces/Interface";

const serviceCenter: dealer = {
  name: "ООО САНТЕХСЕРВИС",
  address: "СПб, Комендантский пр. 4, ТЦ СтройДом, вход №6",
  coordinates: [60.00285905310569, 30.266729470987887],
  workTime: ["пн-пт: 10-19", "сб-вс: выходной"],
  phoneNumbers: ["+7 (812) 448-21-33"],
  webSites: ["https://santeh.spb.ru/"],
  mails: ["salon@santeh.spb.ru"],
};

const ServiceCenter: React.FC<defaultNavigationProps> = ({ navigation }) => {
  return (
    <ContactInfoScreen
      navigation={navigation}
      title="Сервис Deante"
      contact={serviceCenter}
    />
  );
};

export default React.memo(ServiceCenter);
